export class ProcessoConsultadoAssociado {
    id = 0;
    isExiste: boolean;
    numeroProcesso = '';
    nomeAssociado = '';
    associadoTitular = '';
}